// src/pages/Forbidden403Page.jsx — shown when RequireRole redirects to /403
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Forbidden403Page() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div style={{ padding: '48px 32px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '8px' }}>{t('forbidden.title')}</h1>
      <p style={{ color: 'var(--muted, #888)', marginBottom: '24px' }}>
        {t('forbidden.message')}
      </p>
      <button
        className="btn-ghost"
        onClick={() => navigate('/overview', { replace: true })}
      >
        {t('forbidden.back')}
      </button>
    </div>
  );
}
